export const SwitchV2 = ({
  setIsToggled,
  isToggled,
  disabled = false,
}: {
  setIsToggled: (val: boolean) => void;
  isToggled: boolean;
  disabled?: boolean;
}) => {
  return (
    <button
      disabled={disabled}
      className="cursor-pointer disabled:cursor-not-allowed disabled:opacity-40"
      onClick={() => setIsToggled(!isToggled)}
    >
      <div
        className={`relative flex items-center justify-center w-[24px] h-[13.63px] rounded-full transition-all ${
          isToggled ? "bg-[#165FE3]" : "bg-[#D2D2D2]"
        }`}
      >
        <div
          className={`absolute w-[9.38px] h-[9.38px] rounded-full transition-all ${
            isToggled
              ? "bg-[#FFFFFF] left-[13.09px] top-[2.13px]"
              : "bg-[#4A4A4A] left-[2.18px] top-[2.13px]"
          }`}
        ></div>
      </div>
    </button>
  );
};
